import React from "react";

import DialogBase from '../Base/DialogBase';
import SendFax from './SendFax.jsx'

class FaxModal extends DialogBase {
    constructor(props) {
      super(props);
  
      Object.assign(this.state, {
        title: '■FAX送信',
        values:{}
      });
      this.setFaxModal = this.setFaxModal.bind(this)
    }
  
    setFaxModal(data){
      this.setState({
        values:{
          ...data
        },
      },()=>{!this.state.modal&&this.toggleModal()})
    }
  
    bodyContent() {
      return (
        <>
            <SendFax 
              isModal={true}
              toggleModal={this.toggleModal}
              values={this.state.values}
              {...this.props}
            />
        </>
      );
    }
  }

export default FaxModal;